var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 54.8334C51.3262 54.8334 54.8333 51.3263 54.8333 47C54.8333 42.6738 51.3262 39.1667 47 39.1667C42.6738 39.1667 39.1667 42.6738 39.1667 47C39.1667 51.3263 42.6738 54.8334 47 54.8334Z",
    stroke: "#046857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6068 30.3935C65.7918 32.576 67.5251 35.1678 68.7077 38.0206C69.8904 40.8735 70.4991 43.9315 70.4991 47.0197C70.4991 50.108 69.8904 53.166 68.7077 56.0188C67.5251 58.8717 65.7918 61.4635 63.6068 63.646M30.3935 63.6068C28.2086 61.4243 26.4752 58.8325 25.2926 55.9797C24.11 53.1268 23.5013 50.0688 23.5013 46.9806C23.5013 43.8923 24.11 40.8343 25.2926 37.9815C26.4752 35.1286 28.2086 32.5368 30.3935 30.3543M74.691 19.3093C82.0336 26.6542 86.1585 36.6146 86.1585 47.0002C86.1585 57.3858 82.0336 67.3462 74.691 74.691M19.3093 74.691C11.9667 67.3462 7.84188 57.3858 7.84188 47.0002C7.84188 36.6146 11.9667 26.6542 19.3093 19.3093",
    stroke: "#046857",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.4c2a46f9e1d9ab40ea6b1b3ae2b083de.svg";
export { ForwardRef as ReactComponent };